<template>
  <div class='noPage' style='height: 100%;'>
    <ejs-grid ref='grid' :dataSource='data' height='calc(100% - 0px)' :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :dataBound='dataBoundFunc'>
      <e-columns>
        <e-column type='checkbox' textAlign='Center' width='10%'></e-column>
        <e-column field='alarmname' :headerText='$t("Alarm.alarmName")' textAlign='Left' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='alarmtype' :headerText='$t("Alarm.alarmType")' textAlign='Left' minWidth='10' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='typeFormat'></e-column>
        <e-column field='level' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat'></e-column>
        <e-column field='neType' :headerText='$t("Pm.ne_type_id")' textAlign='Left' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>
<script>
import { Reorder, Resize } from '@syncfusion/ej2-vue-grids';

export default {
  name: 'alarmTable',
  provide: {
    grid: [Reorder, Resize]
  },
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      alarmListCache: {}, // 缓存选中的alarmID
      // alarmDataCache: {}, // 缓存选中的数据
      currentDataList: [], // 缓存当前操作的值
      queryConditions: {
        systemId: '',
        neTypeList: [],
        alarmLevelList: []
      },
      data: [],
      clearStatus: false
    };
  },
  methods: {
    typeFormat(grids, data) {
      if (data.alarmtype || data.alarmtype === 0) {
        return this.$t(`Alarm.alarmType_${data.alarmtype}`);
      }
      return '';
    },
    levelFormat(grids, data) {
      if (data.level || data.level === 0) {
        return this.$t(`Alarm.alarmLevel_${data.level}`);
      }
      return '';
    },
    dataBoundFunc() {
      const selectRowIndexList = [];
      Object.entries(this.alarmListCache).forEach((value) => {
        if (value[1] === true) {
          const index = this.data.findIndex(v => v.alarmid+'-'+v.neType == value[0]);
          if (index > -1) {
            selectRowIndexList.push(index);
          }
        }
      });
      this.$refs.grid.selectRows(selectRowIndexList);
    },
    actionComplete() {
      this.$refs.grid.selectRow(0,true);
      this.$refs.grid.selectRow(0,true);
    },

    clearCache() {
      // this.clearStatus = true;
      this.alarmListCache = {};
      // this.alarmDataCache = {};
      this.queryConditions = {
        systemId: '',
        neTypeList: [],
        alarmLevelList: []
      };
      this.getAlarmTableData();
    },
    getCheckedData() {

      return this.$refs.grid.getSelectedRecords();
    },
    getAlarmTableData() {
      const This = this;
      const level = [];
      for (let i = 0; i < This.queryConditions.alarmLevelList.length; i++) {
        level.push(parseInt(This.queryConditions.alarmLevelList[i], 10));
      }
      // 默认查enodeb
      if (This.queryConditions.neTypeList.length < 1) {
        This.queryConditions.neTypeList = ["10004"];
      }
      This.$axios.post('/lte/ems/fm/shield/queryalarm', {
        levelList: level,
        neTypeList: This.queryConditions.neTypeList
      }).then((response) => {
        if (response && response.status === 200) {
          for (let i = 0; i < response.data.resultVal.length; i++){//NM8000-8316 NM8000-8318
            response.data.resultVal[i].neType = response.data.resultVal[i].neType.toUpperCase();
          }
          This.data = response.data.resultVal;
  
        }
      });
    }
  }
};
</script>
